import React from 'react';

interface DiagnosticContributorBoundaryState {
  hasError: boolean;
}

/**
 * Diagnostic adapters are optional observers. An adapter failure must never replace the app UI
 * with the top-level error screen.
 */
export class DiagnosticContributorBoundary extends React.Component<
  React.PropsWithChildren,
  DiagnosticContributorBoundaryState
> {
  state: DiagnosticContributorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): DiagnosticContributorBoundaryState {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
